module.exports = __webpack_public_path__ + "img/directions1.36814a06.png";